export default "__VITE_ASSET__CJk7UbPM__"